// extracted by mini-css-extract-plugin
module.exports = {"packHolder":"style_packHolder__2gHwB","pack":"style_pack__27nfo","name":"style_name__2Se9l","cardCount":"style_cardCount__wd-QF","actionRow":"style_actionRow__1OdmC"};